export default __webpack_public_path__ + "static/media/maoyuan-logo.040b9d9b.png";